import {
  Box,
  Flex,
  Heading,
  Stat,
} from "@chakra-ui/react";

const AgentsOverviewCard = ({ data, index, totalIndexes }) => {
  return (
      <Box
        p={"15px"}
        borderRadius={
          index === 0
            ? "10px 10px 0 0" // Top left and top right
            : index === totalIndexes - 1
              ? "0 0 10px 10px" // Bottom left and bottom right
              : "0" // No border radius
        }
        border="1px solid var(--borderGrey)"
        borderBottom={index === totalIndexes - 1 ? "1px solid var(--borderGrey)" : "none"}
      >
        <Heading fontSize="20px" mb={"10px"}>{data.agentName}</Heading>

        <Flex justify="space-between">
          <Stat.Root>
            <Stat.Label>Total</Stat.Label>
            <Stat.ValueText fontSize="16px" fontWeight={400}>{data.total}</Stat.ValueText>
          </Stat.Root>
          <Stat.Root ml={4}>
            <Stat.Label>Completed</Stat.Label>
            <Stat.ValueText fontSize="16px" fontWeight={400}>{data.completed}</Stat.ValueText>
          </Stat.Root>
          <Stat.Root ml={4}>
            <Stat.Label>Average Time</Stat.Label>
            <Stat.ValueText fontSize="16px" fontWeight={400}>{data.averageTime}</Stat.ValueText>
          </Stat.Root>
        </Flex>
      </Box>
  );
};

export default AgentsOverviewCard;
